/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

const actions = {
	// ////////////////////////////////////////////
	// SIDEBAR & UI UX
	// ////////////////////////////////////////////
	updateSidebarWidth({ commit }, width) {
		commit('updateSideBarWidth', width);
	},
	updateI18nLocale({ commit }, locale) {
		commit('updateI18nLocale', locale);
	},
	updateTheme({ commit }, val) {
		commit('updateTheme', val);
	},

	//  The Navbar
	arrangeStarredPagesLimited({ commit }, list) {
		commit('arrangeStarredPagesLimitted', list);
	},
	arrangeStarredPagesMore({ commit }, list) {
		commit('arrangeStarredPagesMore', list);
	},
	/**
	 * Created by NVHIEN on 09/05/2025
	 * Cập nhật trạng thái popup cập nhật CCCD đang hoạt động
	 */
	setIdentificationPopupSuccessActive: function(context, value) {
		context.commit('updateIdentificationPopupActive', value);
	}
};

export default actions;
